import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  type IDocumentSettings,
  type Orientation,
  type PaperSize,
} from '@principle-theorem/principle-core/interfaces';

export class DocumentSettingsFormGroup extends TypedFormGroup<IDocumentSettings> {
  constructor() {
    super({
      fontFamily: new TypedFormControl<string | undefined>(undefined),
      fontSize: new TypedFormControl<string | undefined>(undefined),
      lineHeight: new TypedFormControl<string | undefined>(undefined),
      paragraphSpacing: new TypedFormControl<string | undefined>(undefined),
      marginTop: new TypedFormControl<number | undefined>(undefined),
      marginBottom: new TypedFormControl<number | undefined>(undefined),
      marginLeft: new TypedFormControl<number | undefined>(undefined),
      marginRight: new TypedFormControl<number | undefined>(undefined),
      paperSize: new TypedFormControl<PaperSize | undefined>(undefined),
      orientation: new TypedFormControl<Orientation | undefined>(undefined),
    });
  }

  setFromSettings(
    settings: Partial<IDocumentSettings> | undefined,
    options?: { emitEvent?: boolean }
  ): void {
    const emitOptions = { emitEvent: options?.emitEvent ?? false };
    if (!settings) {
      this.controls.fontFamily.setValue(undefined, emitOptions);
      this.controls.fontSize.setValue(undefined, emitOptions);
      this.controls.lineHeight.setValue(undefined, emitOptions);
      this.controls.paragraphSpacing.setValue(undefined, emitOptions);
      this.controls.marginTop.setValue(undefined, emitOptions);
      this.controls.marginBottom.setValue(undefined, emitOptions);
      this.controls.marginLeft.setValue(undefined, emitOptions);
      this.controls.marginRight.setValue(undefined, emitOptions);
      this.controls.paperSize.setValue(undefined, emitOptions);
      this.controls.orientation.setValue(undefined, emitOptions);
      return;
    }
    this.controls.fontFamily.setValue(settings.fontFamily, emitOptions);
    this.controls.fontSize.setValue(settings.fontSize, emitOptions);
    this.controls.lineHeight.setValue(settings.lineHeight, emitOptions);
    this.controls.paragraphSpacing.setValue(
      settings.paragraphSpacing,
      emitOptions
    );
    this.controls.marginTop.setValue(settings.marginTop, emitOptions);
    this.controls.marginBottom.setValue(settings.marginBottom, emitOptions);
    this.controls.marginLeft.setValue(settings.marginLeft, emitOptions);
    this.controls.marginRight.setValue(settings.marginRight, emitOptions);
    this.controls.paperSize.setValue(settings.paperSize, emitOptions);
    this.controls.orientation.setValue(settings.orientation, emitOptions);
  }

  toDocumentSettings(): IDocumentSettings {
    return {
      fontFamily: this.controls.fontFamily.value ?? undefined,
      fontSize: this.controls.fontSize.value ?? undefined,
      lineHeight: this.controls.lineHeight.value ?? undefined,
      paragraphSpacing: this.controls.paragraphSpacing.value ?? undefined,
      marginTop: this.controls.marginTop.value ?? undefined,
      marginBottom: this.controls.marginBottom.value ?? undefined,
      marginLeft: this.controls.marginLeft.value ?? undefined,
      marginRight: this.controls.marginRight.value ?? undefined,
      paperSize: this.controls.paperSize.value ?? undefined,
      orientation: this.controls.orientation.value ?? undefined,
    };
  }
}
